import { Flex, Text, Box } from "@chakra-ui/react"
import { useState, useEffect } from "react"
import { useNavigate, useParams } from "react-router-dom"
import { getClassByClassId } from "../../api/classes"
import { storeContent } from "../../api/content"
import { getMaterials } from "../../api/material"
import { Form } from "./components"
import { useForm } from "react-hook-form"
import { joiResolver } from "@hookform/resolvers/joi"
import dayjs from "dayjs"
import Joi from "joi"

function Create() {
  const navigate = useNavigate()
  const { classId } = useParams()
  const initClass = {
    id: "",
    name: "",
    category: {
      name: "",
    },
    subCategory: {
      name: "",
    },
  }
  const schema = Joi.object({
    classId: Joi.string().required(),
    materialId: Joi.string().required(),
    type: Joi.string().required(),
    time: Joi.number().required(),
    startDate: Joi.date().required(),
    startTime: Joi.string().required(),
    endDate: Joi.date().required(),
    endTime: Joi.string().required(),
  })
  const [classBK, setClassBK] = useState({ data: { ...initClass }, isLoading: false, error: null })
  const [content, setContent] = useState({ isLoading: false, error: null })
  const [materials, setMaterials] = useState({ data: [], isLoading: false, error: null })
  const {
    register,
    formState: { errors },
    handleSubmit,
    setValue,
    getValues,
  } = useForm({
    resolver: joiResolver(schema),
    defaultValues: {
      type: "saintek",
    },
  })

  useEffect(() => {
    const GetMaterials = async () => {
      setMaterials({ ...materials, isLoading: true })
      const result = await getMaterials()
      if (result.success) {
        setMaterials({ ...materials, data: result.data.materials, isLoading: false })
      }
    }
    GetMaterials()
    return () => {
      setMaterials({ data: [], isLoading: false, error: null })
    }
  }, [])

  useEffect(() => {
    const GetClass = async () => {
      setClassBK({ ...classBK, isLoading: true })
      const result = await getClassByClassId(classId)
      if (result.success) {
        setValue("classId", result.data.id)
        setClassBK({ ...classBK, data: result.data, isLoading: false })
      }
    }
    GetClass()
    return () => {
      setClassBK({ data: { ...initClass }, isLoading: false, erro: null })
    }
  }, [classId])

  const onSubmit = async (data) => {
    setContent({ ...content, isLoading: true })
    const startTimes = data.startTime.split(":")
    const start = dayjs(data.startDate).hour(startTimes[0]).minute(startTimes[1])
    const endTimes = data.endTime.split(":")
    const end = dayjs(data.endDate).hour(endTimes[0]).minute(endTimes[1])
    const result = await storeContent({ ...data, start, end })
    if (result.success) {
      setContent({ ...content, isLoading: false })
      navigate("/content")
    }
  }

  return (
    <Flex direction="column">
      <Text color="gray.750" fontSize="2xl" fontWeight="medium">
        Kelas
      </Text>
      <Box bg="white" mt="4" px={[4, 6, 8]} py={8}>
        <Flex direction="row" justify="space-between">
          <Text color="gray.750" fontSize="xl" fontWeight="medium">
            Tambah Konten
          </Text>
        </Flex>
        <Form
          type="create"
          classBK={classBK}
          register={register}
          errors={errors}
          handleSubmit={handleSubmit}
          onSubmit={onSubmit}
          content={content}
          materials={materials}
          setValue={setValue}
          getValues={getValues}
        />
      </Box>
    </Flex>
  )
}

export default Create
